// Meeting audio for online calls: Chrome's own "Choose what to share" picker, audio kept, picture dropped.
// Nobody in the call sees this; it is not Meet's "Present now".

export const meetingAudioSupported = () => !!navigator.mediaDevices?.getDisplayMedia;

export async function requestMeetingAudio() {
  if (!meetingAudioSupported()) throw new Error("This browser can't capture meeting audio. Use Chrome or Edge on a computer.");
  let display;
  try {
    display = await navigator.mediaDevices.getDisplayMedia({
      video: true, // Chrome requires a video request; it is discarded below
      audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false, suppressLocalAudioPlayback: false },
      systemAudio: "include",
      selfBrowserSurface: "exclude",
      surfaceSwitching: "include",
      preferCurrentTab: false,
    });
  } catch (e) {
    if (e?.name === "NotAllowedError") throw new Error("Meeting audio was not shared. Pick your Meet tab and turn on “Also share tab audio”.");
    throw e;
  }
  const audio = display.getAudioTracks();
  display.getVideoTracks().forEach((t) => t.stop());
  if (!audio.length) {
    throw new Error("No sound was shared. Pick the Meet tab (not a window) and turn on “Also share tab audio”, or Entire screen with “Also share system audio”.");
  }
  return new MediaStream(audio);
}

export const stopStream = (stream) => stream?.getTracks().forEach((t) => t.stop());
export const isLive = (stream) => !!stream && stream.getAudioTracks().some((t) => t.readyState === "live");

// Setup asks for meeting audio inside the Start click (Chrome needs the click), then hands it to the session page.
let pending = null;
export function setPendingMeetingAudio(sessionId, stream) {
  if (pending && pending.stream !== stream) stopStream(pending.stream);
  pending = { sessionId, stream };
}
// Not consumed on read: React StrictMode runs state initialisers twice in development.
export function takePendingMeetingAudio(sessionId) {
  if (!pending || pending.sessionId !== sessionId) return null;
  return isLive(pending.stream) ? pending.stream : null;
}
